import type { SkeletonProps } from './Skeleton.types'
import cn from 'classnames'
import React from 'react'
import styles from './Skeleton.module.css'

export function Skeleton({ hasAnimation = true, className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(styles.skeleton, { [styles.animation]: hasAnimation }, className)}
      {...props}
    />
  )
}

export function StillSkeleton({ className, ...props }: Omit<SkeletonProps, 'hasAnimation'>) {
  return <div className={cn(styles.skeleton, styles.still, className)} {...props} />
}
